// extracted by mini-css-extract-plugin
module.exports = {"rr_logo":"registation_rr_logo__Qcx_V","mobile_view":"registation_mobile_view__SgDrX","main_box":"registation_main_box__A7lZz","signup_box":"registation_signup_box__Mxgi1"};